import axios from 'axios';

// Determine API base URL - use /hub/api for VPS, /api for development
let baseURL = '/hub/api';
if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.REACT_APP_API_BASE || '/api';
}

const api = axios.create({
  baseURL,
  withCredentials: true
});

export default api;
